import React, { FC } from 'react';
import { Column } from 'components/UI/Column';
import { Row } from 'components/UI/Row';
import { SerialNumberHistoryItemHeader } from './SerialNumberHistoryItemHeader';
import { HistorySnapshotComponent } from './serialNumbers';
import SwapVertIcon from '@material-ui/icons/SwapVert';
import { Typography } from '@material-ui/core';
import { Divider } from 'components/UI/Divider';

interface SerialNumberHistoryItemComponentProps {
    component: HistorySnapshotComponent;
    justifyContent?: string;
}

export const SerialNumberHistoryItemComponent: FC<SerialNumberHistoryItemComponentProps> = ({ component, justifyContent }) => {
    return (
        <Column>
            <Row style={{ marginTop: 20 }} justifyContent={justifyContent}>
                <SerialNumberHistoryItemHeader
                    component={component.name}
                    newProduct={component.new_product?.name}
                    oldProduct={component.old_product?.name}
                />
            </Row>

            <Row style={{ marginTop: 10, marginBottom: 10 }}>
                <Column justifyContent="center">
                    <Row justifyContent={justifyContent}>
                        <Typography color="primary">
                            {component.new_product?.serial_number}
                        </Typography>
                    </Row>

                    <Row justifyContent={justifyContent}>
                        {component.new_product && component.old_product && <SwapVertIcon />}
                    </Row>

                    <Row justifyContent={justifyContent}>
                        <Typography color="secondary">
                            {component.old_product?.serial_number}
                        </Typography>
                    </Row>
                    <Row justifyContent={justifyContent}>
                        <Divider borderType="dashed" style={{ width: 300 }} />
                    </Row>
                </Column>
            </Row>
        </Column>
    )
}